import React from 'react'
import { useTranslation } from 'react-i18next'
import Header from '../component/layout/Header'
import Footer from '../component/layout/Footer'
import UserSession from '../service/UserSession';
import { useHistory } from 'react-router-dom';

const AppContainer = ({children}) => {
    let history = useHistory();
    // history.push('/biom');
    // if(!UserSession.getToken()) {
    //     const _country = localStorage.getItem('_country');
    //     if(_country){
    //         history.push('/login');
    //     } else {
    //         history.push('/country');
    //     }
    // }

    const { i18n } = useTranslation();
    return (        
    <div className={"app-root " + i18n.language}>
        <>
            {/* <Header/> */}
            <div className="container">{children}</div>
                {/* {UserSession.getToken() && <div className="container">{children}</div>} */}
            {/* <Footer/>         */}
        </>
    </div>
    )
}

export default AppContainer;